import config from 'config';
import { Footer as FooterBase } from 'ui/components/templates';
import { useRouterCurrent } from '../../hooks';

export const Footer = () => {
  const { isMainHeader = false, isPublic, path } = useRouterCurrent();

  const allowedWithoutMainHeaderPaths = [
    '/recuperacao-de-senha',
    '/recuperacao-de-senha/email',
    '/recuperacao-de-senha/email/sucesso',
    '/perguntas-frequentes',
  ];

  const showFooter = isPublic && allowedWithoutMainHeaderPaths.includes(path || '');

  if (path?.includes('/gestao-de-vendas') || config.footer.hidden) {
    return <></>;
  }

  if (showFooter) {
    return <FooterBase />;
  }

  if (!isMainHeader) {
    return <></>;
  }

  return <FooterBase />;
};
